/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import React from "react"
import { useSelector } from "react-redux"

import { PRIOR_USE, PROVEN_NO } from "const"
import { ProvenType } from "client/utils"
import { StoreType, LangType } from "client/store"
import { InsufficientData, NotCompliant } from "client/components"

interface SilWrapperProps {
    data: string
}
const SilWrapper = ({ data }: SilWrapperProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <span>
            {`${data} ${lang.capable}`}
        </span>
    )
}

interface Iec_61511_2003 {
    provenInUse: ProvenType
    logicSolver: boolean
    sff: string | number | boolean
    lang: LangType
    silOnly?: boolean
    textError?: boolean
}
export const iec_61511_2003_device = (props: Iec_61511_2003) => {
    const { provenInUse, logicSolver, lang, silOnly, textError } = props
    const sff = typeof props.sff === "string" ? parseFloat(props.sff) : props.sff

    if (logicSolver) {
        if (sff === false || sff === null) return textError ? lang.insufficientData : <InsufficientData />

        if (sff < 0.6) return textError ? lang.notCompliant : <NotCompliant />
        if (sff >= 0.6 && sff < 0.9) return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1} />
        if (sff >= 0.9) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2} />
        return textError ? lang.insufficientData : <InsufficientData />
    }

    if (!logicSolver) {
        if (provenInUse === PRIOR_USE) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2} />
        if (provenInUse === PROVEN_NO) return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1} />
        return textError ? lang.notCompliant : <NotCompliant />
    }
    return textError ? lang.insufficientData : <InsufficientData />
}
